import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import PageLogout from "./Logout.page";

export const LogoutPageRoute = makeObservableRouteDef({
  identifier: 'logout',
  urlFactory: always('logout'),
  composeTitle: always('Logout'),
  component: PageLogout,
})